import React from 'react'
import MainInvoice from '../Views/Web/Invoice/MainInvoice'
import { IndexInvoiceOutgoing, InvoiceOutgoingCreate, InvoiceOutgoingEdit, InvoiceOutgoingMain, InvoiceOutgoingView } from '../Views/Web/Invoice/InvoiceOutgoing'
import { Route } from 'react-router-dom'
import PaymtHistory from '../Views/Web/Invoice/InvoiceOutgoing/PaymtHistory'

function InvoiceRoutes() {
  return (
        <Route path="invoice" element={<MainInvoice />}>
            <Route path="invoice-outgoing" element={<InvoiceOutgoingMain/>} >
             <Route index element={<IndexInvoiceOutgoing/>} />
             <Route path='create' element={<InvoiceOutgoingCreate/>} />
             <Route path='edit/:invoiceOutgoingEditId' element={<InvoiceOutgoingEdit/>} />
             <Route path='view/:invoiceOutgoingViewId' element={<InvoiceOutgoingView/>} />
             <Route path='payment-history/:invoiceOutgoingViewId' element={<PaymtHistory/>} />

            </Route>
            
        </Route>
      )
}

export default InvoiceRoutes